export default __webpack_public_path__ + "static/media/Konecranes.c6e041bc.png";